<template>
<div id="m-top">
  <div class="mt-fixed">
    <div class="bar">
      <router-link :to="$lp('/')" class="logo">
        <img src="../../assets/logo/hope_36x50@2x.png" alt="Hope" width="22">
        <span>
          <small>{{ clinic.corp }}</small>
          <strong>{{ clinic.name }}</strong>
        </span>
      </router-link>
      <div class="r">
        <LangSwitch variant="compact"/>
        <a class="tel" :href="clinic.telHref" :aria-label="$t('btn.tel')" :title="$t('btn.tel')">📞</a>
        <button class="rsv" type="button" @click="openBooking">{{ $t('btn.book') }}</button>
        <button class="hamb" type="button" :aria-label="$t('m.menu')" @click="drawer = true">☰</button>
      </div>
    </div>
    <!-- 科目ストリップ（首页以外で表示） -->
    <nav v-if="!isHome" ref="strip" class="strip" :aria-label="$t('nav.menu')">
      <router-link v-for="d in depts" :key="d.key" :to="$lp(d.path)" :data-k="d.key"
                   :class="{ on: current && current.key === d.key, hot: d.feat }">
        {{ d.icon }} {{ d.short }}
      </router-link>
    </nav>
  </div>
  <div class="mt-space" :class="{ tall: !isHome }"></div>
  <SiteNotice/>

  <!-- ドロワーメニュー -->
  <div class="dmask" :class="{ open: drawer }" @click="drawer = false"></div>
  <aside class="drawer" :class="{ open: drawer }" :aria-label="$t('m.siteMenu')">
    <div class="dh"><b>{{ $t('m.menu') }}</b><button type="button" :aria-label="$t('m.close')" @click="drawer = false">×</button></div>
    <h4>{{ $t('m.language') }}</h4>
    <LangSwitch variant="row"/>
    <h4>{{ $t('nav.menu') }}</h4>
    <router-link v-for="d in depts" :key="d.key" :to="$lp(d.path)">{{ d.icon }} {{ d.name }}</router-link>
    <h4>{{ $t('m.bookContact') }}</h4>
    <router-link :to="$lp({ path: '/', hash: '#menu' })">{{ $t('m.priceWays') }}</router-link>
    <router-link :to="$lp('/sending')">{{ $t('nav.contact') }}</router-link>
    <h4>{{ $t('m.info') }}</h4>
    <router-link :to="$lp('/about')">{{ $t('m.aboutDoctors') }}</router-link>
    <router-link :to="$lp({ path: '/', hash: '#hours' })">{{ $t('m.hours') }}</router-link>
    <router-link :to="$lp({ path: '/', hash: '#access' })">{{ $t('nav.access') }}</router-link>
    <router-link :to="$lp('/information')">{{ $t('nav.news') }}</router-link>
    <button class="d-rsv" type="button" @click="drawer = false; openBooking()">{{ $t('btn.book') }}</button>
  </aside>
</div>
</template>

<script>
import { L } from '@/data/localized'
import { stripLang } from '@/i18n'
import SiteNotice from '@/components/v6/SiteNotice'
import LangSwitch from '@/components/v6/LangSwitch'

export default {
  name: "MTop",
  components: { SiteNotice, LangSwitch },
  data() {
    return { drawer: false }
  },
  computed: {
    clinic() { return L.clinic(this.$lang) },
    depts() { return L.depts(this.$lang) },
    isHome() { return stripLang(this.$route.path) === '/' },
    current() { return L.deptByPath(this.$route.path, this.$lang) },
  },
  watch: {
    $route() {
      this.drawer = false
      this.$nextTick(this.centerStrip)
    },
    drawer(v) { document.body.classList.toggle('v6-lock', v) },
  },
  mounted() {
    this.$nextTick(this.centerStrip)
  },
  methods: {
    openBooking() {
      this.$store.commit('openBooking', this.current ? this.current.key : null)
    },
    // 現在の科目を横スクロールの中央へ（ページ自体はスクロールさせない）
    centerStrip() {
      const s = this.$refs.strip
      if (!s) return
      const a = s.querySelector('a.on')
      if (a) s.scrollLeft = a.offsetLeft - (s.clientWidth - a.offsetWidth) / 2
    },
  },
}
</script>

<style scoped>
.mt-fixed{position:fixed;top:0;left:0;right:0;z-index:1024;background:#fff;border-bottom:1px solid var(--v6-bd)}
.bar{height:56px;display:flex;align-items:center;justify-content:space-between;padding:0 8px 0 10px;gap:6px}
.logo{display:flex;align-items:center;gap:6px;text-decoration:none;min-width:0;overflow:hidden}
.logo img{flex:none}
.logo small{display:block;font-size:9.5px;color:#9e9e9e;line-height:1.2;font-weight:700}
.logo strong{display:block;font-size:14px;color:var(--v6-brand);line-height:1.25;white-space:nowrap}
.r{display:flex;align-items:center;gap:4px;flex:none}
.tel,.rsv{display:inline-flex;align-items:center;justify-content:center;height:34px;width:70px;padding:0;border-radius:8px;font-size:12.5px;font-weight:700;white-space:nowrap;box-sizing:border-box;font-family:inherit;line-height:1}
/* 言語ボタンを置いたぶん、電話は📞だけ（下の固定バーにも「電話」がある） */
.tel{border:1.5px solid var(--v6-brand);color:var(--v6-brand-d);text-decoration:none;background:#fff;width:34px;font-size:15px}
.rsv{background:var(--v6-cta);color:#fff;border:1.5px solid var(--v6-cta);width:auto;min-width:46px;padding:0 9px}
.hamb{background:none;border:none;font-size:22px;width:30px;height:34px;color:var(--v6-ink);padding:0}
@media (max-width:400px){.logo strong{font-size:13px}}
@media (max-width:380px){.logo strong{font-size:12.5px}.rsv{padding:0 6px}}
@media (max-width:370px){.tel{display:none}}
.strip{display:flex;overflow-x:auto;white-space:nowrap;scrollbar-width:none;height:40px;border-top:1px solid var(--v6-bd)}
.strip::-webkit-scrollbar{display:none}
.strip a{flex:none;display:inline-flex;align-items:center;height:40px;padding:0 11px;font-size:12.5px;color:var(--v6-ink);text-decoration:none;border-bottom:2px solid transparent;box-sizing:border-box}
.strip a.on{border-bottom-color:var(--v6-brand);color:var(--v6-brand-d);font-weight:700}
.strip a.hot{color:var(--v6-cta-d)}
.mt-space{height:57px}
.mt-space.tall{height:98px}
.dmask{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.4);z-index:2500;opacity:0;pointer-events:none;transition:opacity .2s}
.dmask.open{opacity:1;pointer-events:auto}
.drawer{position:fixed;top:0;right:0;bottom:0;width:84vw;max-width:340px;background:#fff;z-index:2501;transform:translateX(100%);transition:transform .25s;overflow:auto;padding:14px 18px 30px;box-sizing:border-box;color:var(--v6-ink)}
.drawer.open{transform:none}
.dh{display:flex;justify-content:space-between;align-items:center}
.dh button{background:none;border:none;font-size:24px;color:var(--v6-sub)}
.drawer h4{font-size:11px;color:var(--v6-sub);letter-spacing:.1em;margin:16px 0 4px}
.drawer a{display:flex;justify-content:space-between;padding:11px 2px;border-bottom:1px solid var(--v6-bd);font-size:14px;color:var(--v6-ink);text-decoration:none}
.drawer a::after{content:"›";color:var(--v6-sub)}
.d-rsv{width:100%;margin-top:18px;background:var(--v6-cta);color:#fff;border:none;border-radius:8px;padding:13px;font-size:15px;font-weight:700;font-family:inherit}
</style>
